import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

export const api = {
  listProducts: (params = {}) => client.get("/products", { params }).then((r) => r.data),
  getProduct: (id) => client.get(`/products/${id}`).then((r) => r.data),
  getSellers: (id) => client.get(`/products/${id}/sellers`).then((r) => r.data),
  getComplaints: (id, limit = 100) =>
    client.get(`/products/${id}/complaints`, { params: { limit } }).then((r) => r.data),
  getProductStats: (id) => client.get(`/products/${id}/stats`).then((r) => r.data),
  latestComplaints: (limit = 25) =>
    client.get("/complaints/latest", { params: { limit } }).then((r) => r.data),
  topProducts: (limit = 8) =>
    client.get("/products/top", { params: { limit } }).then((r) => r.data),
  overview: () => client.get("/dashboard/overview").then((r) => r.data),
  trends: (days = 30) => client.get("/dashboard/trends", { params: { days } }).then((r) => r.data),
  alerts: (limit = 10) => client.get("/dashboard/alerts", { params: { limit } }).then((r) => r.data),
  analyze: (text) => client.post("/analyze-complaint", { text }).then((r) => r.data),
  registerUser: (payload) => client.post("/users/register", payload).then((r) => r.data),
  userStats: () => client.get("/users/stats").then((r) => r.data),
  scanProduct: (image_base64, mime_type = "image/jpeg") =>
    client.post("/products/scan", { image_base64, mime_type }).then((r) => r.data),
  compareProducts: (ids) =>
    client.get("/compare/products", { params: { ids: ids.join(",") } }).then((r) => r.data),
  exportComplaintsCsvUrl: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return `${API}/complaints/export.csv${qs ? `?${qs}` : ""}`;
  },
  listBrands: () => client.get("/brands").then((r) => r.data),
  getBrand: (brand) => client.get(`/brands/${encodeURIComponent(brand)}`).then((r) => r.data),
  sendTeamMessage: (payload) => client.post("/team/messages", payload).then((r) => r.data),
  listTeamMessages: (params = {}) => client.get("/team/messages", { params }).then((r) => r.data),
};
